import { render, staticRenderFns } from "./ArchivesManagementList.vue?vue&type=template&id=19bc297f&"
import script from "./ArchivesManagementList.vue?vue&type=script&lang=js&"
export * from "./ArchivesManagementList.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesManagementList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports